// extracted by mini-css-extract-plugin
export default {"settings":"Settings_settings__8oQjE","navCards":"Settings_navCards__qCT+2"};